@import '../../themes/capsule.globals';

:host {
  display: block;

  --filter: auto;
  --height: 24px;
  --width: 24px;
  --inset: 0px;
  --computed-height: calc(var(--height) - (2 * var(--inset)));
  --computed-width: calc(var(--width) - (2 * var(--inset)));

  --icon-color: var(--icon-color, currentColor);
  --icon-fill-color: var(--icon-fill-color, var(--icon-color, currentColor));
  --icon-stroke-color: var(--icon-stroke-color, var(--icon-color, currentColor));

  width: var(--width);
  height: var(--height);

  .foreground-0 {
    fill: var(--cpsl-color-foreground-0);
    stop-color: var(--cpsl-color-foreground-0);
  }
  .accent-0 {
    fill: var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
    stop-color: var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));
  }
}

:host div {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: var(--icon-border, auto);
  border-radius: var(--icon-border-radius, 0);
  background: var(--icon-background, transparent);

  color: var(--icon-color);

  box-sizing: border-box;
}

:host svg {
  width: var(--computed-width, '100%');
  height: var(--computed-height, '100%');
  filter: var(--filter);
  border-radius: var(--icon-border-radius, 0);

  & .background-16 {
    fill: var(--cpsl-color-background-16);
  }

  & .foreground-0 {
    fill: var(--cpsl-color-foreground-0);
  }

  & .fill {
    fill: var(--icon-fill-color);
  }

  & .stroke {
    stroke: var(--icon-stroke-color);
  }
}

:host img {
  width: var(--computed-width, 100%);
  height: var(--computed-height, 100%);
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
